export function fmtMoney(v: number) {
    return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
}

export function fmtN(v: number) {
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
    if (v >= 1_000) return `${(v / 1_000).toFixed(1)}K`;
    return v.toLocaleString('pt-BR');
}

export function fmtPct(v: number, d = 1) { return `${v.toFixed(d)}%`; }

export const TZ_LABEL: Record<string, string> = {
    'America/Bogota': 'Bogotá',
    'America/Buenos_Aires': 'Buenos Aires',
    'America/Mexico_City': 'México',
    'America/Santiago': 'Santiago',
    'Europe/Madrid': 'Madrid',
    'Europe/Paris': 'Paris',
    'Europe/Rome': 'Roma',
    'America/Toronto': 'Toronto',
    'America/Lima': 'Lima',
    'America/New_York': 'Nova York',
    'Europe/Berlin': 'Berlim',
    'Europe/London': 'Londres',
    'Europe/Amsterdam': 'Amsterdã',
    'Australia/Sydney': 'Sydney',
    'Europe/Zurich': 'Zurique',
};

export function revenueIntensityClass(value: number, max: number): string {
    if (!value || !max) return 'text-red-500';
    const i = value / max;
    if (i > 0.7) return 'text-emerald-700 font-bold';
    if (i > 0.3) return 'text-emerald-600';
    return 'text-emerald-500';
}

export function fmtDate(iso: string): string {
    try {
        const parts = iso.split('-');
        return `${parts[2]}/${parts[1]}`;
    } catch {
        return iso;
    }
}

export const STATUS_LABEL: Record<string, string> = {
    sent: 'Enviado',
    pending: 'Pendente',
    processing: 'Processando',
    failed: 'Falhou',
    translating: 'Traduzindo',
    cancelled: 'Cancelado',
};

export const STATUS_COLOR: Record<string, string> = {
    sent: 'bg-emerald-100 text-emerald-700',
    pending: 'bg-amber-100 text-amber-700',
    processing: 'bg-blue-100 text-blue-700',
    failed: 'bg-red-100 text-red-700',
    translating: 'bg-purple-100 text-purple-700',
    cancelled: 'bg-gray-100 text-gray-500',
};

